<sc-no-data-container fitHeight [hasData]="dataSource.data.length>0">
  <sc-scroll-pane>
    <table mat-table class="mat-table-selection" [dataSource]="dataSource">

      <ng-container matColumnDef="usageTimestamp">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.rfidcardprotocol.table.usageTimestamp"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.usageTimestamp}} </td>
      </ng-container>

      <ng-container matColumnDef="usageLocation">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.rfidcardprotocol.table.usageLocation"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.usageLocation}} </td>
      </ng-container>

      <ng-container matColumnDef="rfidCardNumber">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.rfidcardprotocol.table.rfidCardNumber"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.rfidCardNumber}} </td>
      </ng-container>

      <ng-container matColumnDef="rfidCardDescription">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.rfidcardprotocol.table.rfidCardDescription"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.rfidCardDescription}} </td>
      </ng-container>

      <ng-container matColumnDef="accessAllowed">
        <th mat-header-cell *matHeaderCellDef>
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.rfidcard.rfidcardprotocol.table.accessAllowed"></sc-dictionary-label>
        </th>
        <td mat-cell class="text-selection" *matCellDef="let protocolEntry"> {{protocolEntry.accessAllowed}} </td>
      </ng-container>

      <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let visit"></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

      <tr mat-row *matRowDef="let protocolEntry; columns: columnsToDisplay"></tr>

    </table>
  </sc-scroll-pane>
</sc-no-data-container>
